import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getApiErrorMessage } from '@/services/fetcher';
import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';

import { changeContractStatus } from '../data-provider';
import type { ChangeContractStatusParams } from '../models';
import { CACHE_KEYS } from '../types';

export const useChangeContractStatus = ({ onSuccess }: { onSuccess?: () => void } = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: ChangeContractStatusParams) => changeContractStatus(params),
    onError: async (error) => {
      const message = await getApiErrorMessage(error);

      showNotification({
        message: message ?? 'An error has occurred. Please, try again',
        type: NOTIFICATION_TYPES.ERROR,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CACHE_KEYS.all });
      showNotification({
        message: 'Successfully changed the contract status',
        type: NOTIFICATION_TYPES.SUCCESS,
      });
      onSuccess?.();
    },
  });
};
